import {useTranslation} from "react-i18next";
import { v4 as uuidv4 } from 'uuid';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import SectionProgram from "./Program/SectionProgram";
import useEventProgram from "../../hooks/useEventProgram";

export default function Program(
    {
        id
    }
) {
    const { t } = useTranslation();
    const [programData, dispatch] = useEventProgram(id);

    if (!programData) {
        return null;
    }

    const dateKeys = Object.keys(programData.program);

    return (
        <div
            className="tab-panel active"
            id="program">
            <p dangerouslySetInnerHTML={{__html: t('conferences.conference.addReportTaFavoriteCaption')}} />
            <Tabs className="tabs-vertical">
                <div className="menu-scrollable">
                    <TabList className="nav-tabs-vertical">
                        {
                            dateKeys.map(
                                date => <Tab key={uuidv4()} selectedClassName="active">{ date }</Tab>
                            )
                        }
                    </TabList>
                </div>
                <div className="tabs-content-vertical">
                    { Object.values(programData.program).map(
                            sections => {
                                return (
                                    <TabPanel>
                                        <SectionProgram
                                            id={id}
                                            sections={sections}
                                            reports={programData.reports}
                                            dispatch={dispatch}
                                        />
                                    </TabPanel>
                                );
                            }
                        )
                    }
                </div>
            </Tabs>
            <p className="note">
                { t('conferences.conference.programCouldBeChanged') }
            </p>
        </div>
    );
}
